// @ts-nocheck
export { Game } from "./game-base";
import "./setup";
import "./menu";
import "./learn";
import "./online";
import "./protocol";
import "./shop";
import { wireSpellCatalogSearch } from "./spell-catalog-search";
import "./draft";
import "./sim";
import "./ui";
import "./profile";
import "./alpha-splash";
import "./effects";
import "./render";
import "./hud";
import "./slot-drag";
import "../status-fx";

wireSpellCatalogSearch();
